import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

// Material UI
import Tooltip from '@material-ui/core/Tooltip';

import { MailOffIcon } from '../_core/_ui/icons.component';
import { isContactReachGap } from '../../lib/helpers/contact-reach.helpers';
import { useCompanySportTerminology } from '../../lib/stores/company.store';
import { getMessages } from './contact-reach.messages';

interface IContactReachIconProps {
  // Absent while loading, null when the server couldn't read the contacts: no icon either way.
  contactReach?: ContactReach | null;
}

// Flags a list row whose family no send can reach; reachable rows render nothing.
export const ContactReachIcon: React.FC<IContactReachIconProps> = ({ contactReach }) => {
  const intl = useIntl();
  const termLookup = useCompanySportTerminology();
  const messages = useMemo(() => getMessages(termLookup), [termLookup]);

  if (!isContactReachGap(contactReach)) return null;

  const label = intl.formatMessage(contactReach === 'NO_CONTACTS' ? messages.tooltipNoContacts : messages.tooltipUnreachable);
  return (
    <Tooltip title={label}>
      <MailOffIcon color="error" titleAccess={label} />
    </Tooltip>
  );
};
